import { all, takeEvery, call, put } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import { list, getData, clearRange } from "services/apis/bucket";
import actions from "./actions";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* LIST({ payload }) {
  yield loading(true);

  const response = yield call(list, payload);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        list: response,
        isBucketFetched: false,
      },
    });
  }
  if (!response) {
    yield loading(false, true);
  }
}

export function* GET_DATA({ payload }) {
  const { bucketId } = payload;
  yield loading(true);

  const response = yield call(getData, bucketId);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        bucketData: response,
        isBucketFetched: true,
      },
    });
  }
  if (!response) {
    yield loading(false, true);
  }
}

export function* CLEAR_RANGE({ payload }) {
  const { body, filter } = payload;
  yield put({
    type: actions.SET_STATE,
    payload: {
      clearRangeLoading: true,
      error: false,
    },
  });

  const response = yield call(clearRange, body);
  if (response) {
    toastr.success("delete succeeded", "history records were deleted");
    yield put({
      type: actions.SET_STATE,
      payload: {
        clearRangeLoading: false,
        list: {},
        bucketData: {},
        isBucketFetched: false,
        lastClearAt: Date.now(),
      },
    });
    yield put({ type: actions.LIST, payload: filter });
  }

  if (!response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        clearRangeLoading: false,
        error: true,
      },
    });
  }
}

export function* CLEAR_LIST() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      list: {},
      loading: false,
      isBucketFetched: false,
    },
  });
}

export function* CLEAR_DATA() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      bucketData: {},
      loading: false,
      isBucketFetched: false,
    },
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LIST, LIST),
    takeEvery(actions.GET_DATA, GET_DATA),
    takeEvery(actions.CLEAR_RANGE, CLEAR_RANGE),
    takeEvery(actions.CLEAR_LIST, CLEAR_LIST),
    takeEvery(actions.CLEAR_DATA, CLEAR_DATA),
  ]);
}
